import type {FC} from 'react';
import {
  Create,
  Datagrid,
  DeleteButton,
  Edit,
  EditButton,
  email,
  List,
  required,
  SelectInput,
  SimpleForm,
  TextField,
  TextInput,
} from 'react-admin';

const ORGANIZATIONS = [
  {id: 'FORTOP', name: 'FORTOP'},
  {id: 'ASEFOR', name: 'ASEFOR'},
  {id: 'FINSA', name: 'FINSA'},
  {id: 'GEOMATICO', name: 'GEOMATICO'},
  {id: 'UVIGO', name: 'UVIGO'},
  {id: 'ITG', name: 'ITG'},
];

export const UserList: FC = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField source="username" />
      <TextField source="email" />
      <TextField source="firstName" label="First Name" />
      <TextField source="lastName" label="Last Name" />
      <TextField source="organization" />
      <TextField source="createdAt" label="Created" />
      <TextField source="updatedAt" label="Updated" />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

export const UserEdit: FC = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="username" validate={[required()]} />
      <TextInput source="email" validate={[required(), email()]} />
      <TextInput source="firstName" label="First Name" validate={[required()]} />
      <TextInput source="lastName" label="Last Name" validate={[required()]} />
      <SelectInput source="organization" choices={ORGANIZATIONS} validate={[required()]} />
    </SimpleForm>
  </Edit>
);

export const UserCreate: FC = () => (
  <Create>
    <SimpleForm>
      <TextInput source="username" validate={[required()]} />
      <TextInput source="email" validate={[required(), email()]} />
      <TextInput source="password" type="password" validate={[required()]} />
      <TextInput source="firstName" label="First Name" validate={[required()]} />
      <TextInput source="lastName" label="Last Name" validate={[required()]} />
      <SelectInput source="organization" choices={ORGANIZATIONS} validate={[required()]} />
    </SimpleForm>
  </Create>
);
